module.exports = __webpack_public_path__ + "static/img/包裝第十組組長-陳美玲.166a387.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/包裝第十組組長-陳美玲.jpg
// module id = 4ClO
// module chunks = 1